export default __webpack_public_path__ + "static/media/mongoDB.31aec3de.png";